import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { ConfigService } from './config.service';
import { CostCenter } from 'src/shared/models/cost-center.model';
import { CostCenterService } from './cost-center.service';
import { ShiftBlock } from '../models/shift-block.model';
import { ShiftBlockService } from './shift-block.service';
import { ShiftRecord } from 'src/shared/models/shift-record.model';
import { ShiftRecordServiceBase } from './shift-record-base.service';
import { TotalUosDetails } from '../models/total-uos-details.model';

@Injectable({
    providedIn: 'root'
})
export class TotalUOSShiftRecordService extends ShiftRecordServiceBase {

    constructor(
      protected _configService: ConfigService,
      protected _http: HttpClient,
      protected _costCenterService: CostCenterService,
      protected _shiftBlockService: ShiftBlockService) {	
          super(_configService, _http, _costCenterService, _shiftBlockService);
    }

    getShiftRecordsForTotalUosActuals(shiftBlockIds: number[], workflowTimeFacilities: string[]): Promise<ShiftRecord[]> {
        const params = new HttpParams().set('shiftBlockIds', JSON.stringify(shiftBlockIds))
                                        .set('workflowTimeFacilities', JSON.stringify(workflowTimeFacilities));

        return this._http.get<ShiftRecord[]>(`${this._apiServer}GetShiftRecordsForTotalUosActuals`, { params : params }).toPromise<ShiftRecord[]>();
    }

    getShiftRecordsForTotalUosReasons(shiftBlockIds: number[], workflowTimeFacilities: string[]): Promise<ShiftRecord[]> {
        const params = new HttpParams().set('shiftBlockIds', JSON.stringify(shiftBlockIds))
                                        .set('workflowTimeFacilities', JSON.stringify(workflowTimeFacilities));

        return this._http.get<ShiftRecord[]>(`${this._apiServer}GetShiftRecordsForTotalUosReasons`, { params : params }).toPromise<ShiftRecord[]>();
    }

    protected getPreviousShiftBlockPromise(costCenter: CostCenter, shiftBlock: ShiftBlock, workflowTimeFacility: string) {
        return this._shiftBlockService.getPreviousShiftBlockForDate(costCenter.id, workflowTimeFacility);
    }

    protected async prepareShiftRecordDetails(costCenter: CostCenter, shiftBlock: ShiftBlock, shiftRecord: ShiftRecord, workflowTime: string): Promise<ShiftRecord> {
        let preparedShiftRecord = this.prepareShiftRecord(costCenter, shiftBlock, shiftRecord, workflowTime);
        let details = await this.getTotalUOSDetails(preparedShiftRecord);
             
        preparedShiftRecord.measureRecords = details.measures;
        preparedShiftRecord.staffingPlans = details.staffingPlans;
        preparedShiftRecord.varianceReasonRecords = details.varianceReasons;
        preparedShiftRecord.unitOfServiceRecords = details.unitOfServiceRecords;

        return preparedShiftRecord;
    }

    async getTotalUOSDetails(shiftRecord: ShiftRecord): Promise<TotalUosDetails> {
        var apiServer = this._configService.appSettings.webApiServer  + "api/TotalUos/";
        let shiftRecordId = shiftRecord.id ? shiftRecord.id : 0;

        const params = new HttpParams()
            .set('shiftRecordId', shiftRecordId.toString());

        return await this._http.get<TotalUosDetails>(`${apiServer}GetTotalUosDetails`, { params: params }).toPromise<TotalUosDetails>();
    }
}
